import { Fragment, useCallback, useEffect, useState } from "react";
import { Listbox } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getSelection, $isRangeSelection, LexicalEditor } from "lexical";
import { $createHeadingNode, $isHeadingNode, HeadingNode, HeadingTagType } from '@lexical/rich-text';
import { $wrapNodes } from '@lexical/selection';
import { List, ListItem } from "../components/List";
import { useIntl } from "react-intl";

export const BlockTypeNameMap =
{
    p: 'Paragraph',
    h1: 'Heading 1',
    h2: 'Heading 2',
    h3: 'Heading 3',
    h4: 'Heading 4',
    h5: 'Heading 5',
    h6: 'Heading 6',
    q: 'Quote',
    pre: 'Code',
};

const DefaultBlockType = 'p';

const formatHeading = (editor: LexicalEditor, headingSize: HeadingTagType) =>
{
    editor.update(() =>
    {
        const selection = $getSelection();
        if ($isRangeSelection(selection))
        {
            $wrapNodes(selection, () => $createHeadingNode(headingSize));
        }
    });
};

export function BlockType()
{
    const [editor] = useLexicalComposerContext();
    const intl = useIntl();
    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.toolbar;
    const [value, setValue] = useState<keyof typeof BlockTypeNameMap>(DefaultBlockType);
    useEffect(() =>
    {
        return editor.registerUpdateListener(({ editorState }) =>
        {
            editorState.read(() =>
            {
                const selection = $getSelection();
                if (!$isRangeSelection(selection)) { return; }
                const node = selection.anchor.getNode().getTopLevelElement(); //?.getType() ?? '';
                if ($isHeadingNode(node))
                {
                    const headingNode = node as HeadingNode;
                    setValue(headingNode.getTag());
                }
                else
                {
                    setValue('' as keyof typeof BlockTypeNameMap);
                }
            });
        });
    },
    [editor]);
    const handleOnChange = useCallback((value) =>
    {
        formatHeading(editor, value);
    },
    [editor]);
    const element =
    <List value={value} title={BlockTypeNameMap[value]} onChange={handleOnChange} placeholder={translations?.blockPlaceholder ?? 'Block'} className="menu block-type-list">
        {Object.entries(BlockTypeNameMap).map(([value, title]) => <ListItem key={value} value={value} title={title} tag={value as keyof JSX.IntrinsicElements} />)}
    </List>;
    return element;
}
